import { render, staticRenderFns } from "./staffGrantDetail.vue?vue&type=template&id=6eff74dc&scoped=true&"
import script from "./staffGrantDetail.vue?vue&type=script&lang=js&"
export * from "./staffGrantDetail.vue?vue&type=script&lang=js&"
import style0 from "./staffGrantDetail.vue?vue&type=style&index=0&id=6eff74dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eff74dc",
  null
  
)

export default component.exports